// extracted by mini-css-extract-plugin
module.exports = {"vin":"CarTitle-vin-1ssOY","moderation":"CarTitle-moderation-15sXE","action":"CarTitle-action-5geLY"};